module.exports = __webpack_public_path__ + "static/media/sadBerry.7c8ae6b4.svg";